export const ENV = {
  BASE_API_URL: process.env.REACT_APP_API_URL,
  PREVIEW_URL: process.env.REACT_APP_PREVIEW_URL,
  VIEW_URL: process.env.REACT_APP_VIEW_URL,
  MAPBOX_API_KEY: process.env.REACT_APP_MAPBOX_API,
  SITES_URL: process.env.REACT_APP_SITES_URL,
};
